import request from '@/utils/request'

/**
 * 【异步导出任务】查询
 * @param {import('@/types/generated/openapi').paths['/export-async-task/find']['get']['parameters']['query']} params
 * @return {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/export-async-task/find']['get']['responses']['200']['content']['application/json']>>}
 */
export function findExportAsyncTask(params) {
  return request({
    url: '/export-async-task/find',
    method: 'get',
    params
  })
}

/**
 * 【异步导出任务】根据任务编号下载文件
 * @param {number} id 任务编号
 * @returns {Promise<{response: Response, blob: Blob, filename: string}>}
 */
export function downloadExportAsyncTaskFileById(id) {
  return request({
    url: `export-async-task/download?id=${id}`,
    method: 'get',
    responseType: 'blob'
  }).then(response => {
    const filename = response.headers['content-disposition']?.split('filename=')[1]
    const decodedFilename = filename ? decodeURIComponent(filename.replace(/\+/g, '%20')) : filename
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    return { response, blob, filename: decodedFilename }
  })
}

/**
 * 【异步导出任务】导出
 * @param {import('@/types/generated/openapi').paths['/export-async-task/export']['get']['parameters']['query']} params 查询参数
 * @returns {Promise<{response: Response, blob: Blob, filename: string}>}
 */
export function exportExportAsyncTask(params) {
  return request({
    url: 'export-async-task/export',
    method: 'get',
    params,
    responseType: 'blob'
  }).then(response => {
    const filename = response.headers['content-disposition']?.split('filename=')[1]
    const decodedFilename = filename ? decodeURIComponent(filename.replace(/\+/g, '%20')) : filename
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    return { response, blob, filename: decodedFilename }
  })
}
